export default{
    channelLogoList:{
        "ayd_wx":"爱婴岛",
        "ays_wx":'爱婴室',
        "bbx_wx":'贝贝熊',
        "bbzx_wx":'宝贝在线',
        "dkbb_wx":'登康 baby',
        "dkhes_wx":'登康好儿尚',
        "hzw_wx":'孩子王',
        "ly_wx":'乐友',
        "ms_wx":'米氏',
        "snhhz_wx":'苏宁红孩子',
        "xfx_wx":'小飞象',
        "xyyay_wx":'喜阳阳爱婴',
        "ybe_wx":'婴贝儿',
        "yy_wx":'咿呀',
        "zy_wx":'四川中亿'
    },
    channelNoLogoList:{
        'xhs_wx':"小红书",
        'bbs_wx':"宝宝树",
        'my_wx':"美柚",
        'lmb_wx':"辣妈帮",
        'mmb_wx':"妈妈帮",
        'yew_wx':"育儿网",
        'qbb_wx':"亲宝宝"
    },
    channelLogoAppList:{
        'xhs_app':"小红书",
        'bbs_app':"宝宝树",
        'my_app':"美柚",
        'lmb_app':"辣妈帮",
        'mmb_app':"妈妈帮",
        'yew_app':"育儿网",
        'qbb_app':"亲宝宝"
    }
}